var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlansIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.095,
    height: 18.098,
    viewBox: "0 0 18.095 18.098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "plans-icon",
    d: "M1.417,13.479A8.489,8.489,0,0,0,.033,16.5,1.311,1.311,0,0,0,1.6,18.065a8.492,8.492,0,0,0,3.011-1.383h0a2.263,2.263,0,0,0-3.2-3.2Zm2.132,2.133h0a7.592,7.592,0,0,1-1.96.893,7.615,7.615,0,0,1,.893-1.96.754.754,0,1,1,1.066,1.066Zm10.023-9.2a1.885,1.885,0,1,1-1.885-1.885A1.885,1.885,0,0,1,13.572,6.409ZM15.812,0h0a11.677,11.677,0,0,0-9.3,4.528,8.343,8.343,0,0,0-3.445.877A6.107,6.107,0,0,0,.183,8.169,2.228,2.228,0,0,0,.372,10.28a2.269,2.269,0,0,0,1.9,1.029H4.147a2.652,2.652,0,0,1,2.639,2.639v1.874a2.269,2.269,0,0,0,1.028,1.9,2.228,2.228,0,0,0,2.111.188,6.107,6.107,0,0,0,2.764-2.882,8.343,8.343,0,0,0,.877-3.445A11.692,11.692,0,0,0,18.1,2.262,2.269,2.269,0,0,0,15.812,0ZM3.277,9.8h-1a.754.754,0,0,1-.641-.348.716.716,0,0,1-.064-.686A4.657,4.657,0,0,1,3.741,6.753a6.78,6.78,0,0,1,1.5-.543A25.907,25.907,0,0,0,3.277,9.8Zm8.068,4.552a4.66,4.66,0,0,1-2.014,2.174.717.717,0,0,1-.687-.064.754.754,0,0,1-.348-.641v-1a25.907,25.907,0,0,0,3.591-1.967,6.781,6.781,0,0,1-.545,1.5Zm.1-3.031a22.559,22.559,0,0,1-3.22,1.863A4.147,4.147,0,0,0,4.908,9.869,22.559,22.559,0,0,1,6.772,6.651c2.539-3.542,5.171-5.033,9.061-5.144a.754.754,0,0,1,.754.733c-.111,3.912-1.6,6.543-5.144,9.082Z",
    transform: "translate(0 0)",
    fill: "CurrentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlansIcon);
export default __webpack_public_path__ + "static/media/plans-icon.2e20e2558bb8f154da85cf9ab82cc2b8.svg";
export { ForwardRef as ReactComponent };